import React, { Suspense } from 'react';
import { RouteProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';

import { useAuth } from '../../Auth/AuthContext';
import { AppRoutes } from '../routing.model';

interface PrivateRouteProps extends RouteProps {
  redirectPath?: string;
  suspense?: boolean;
}

export const CallerRoute: React.FC<PrivateRouteProps> = ({ redirectPath, render, suspense, ...rest }) => {
  const { isAdmin, isAuth, isCreator, isAuthenticating } = useAuth();

  return isAuthenticating ? null : (
    <Route
      {...rest}
      render={
        (isAdmin || isCreator) && isAuth
          ? (...props) => (suspense ? <Suspense fallback={null}>{render(...props)}</Suspense> : render(...props))
          : () => (
              <Redirect
                to={{
                  pathname: redirectPath || AppRoutes.HOME,
                  state: { from: rest.location },
                }}
              />
            )
      }
    />
  );
};
